<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>
<div class="mainContent">
  <h2 mat-dialog-title>{{ 'SELECTDATESRANGE' | translate }}</h2>

  <mat-dialog-content>
    <mat-form-field appearance="outline" class="form-field" style="margin-top: 10px;">
      <mat-label>{{ 'DIVISION' | translate }}</mat-label>
      <mat-select
        multiple
        [(value)]="selectedDivisions"
        (selectionChange)="checkSelection()">
        
        <!-- <mat-option
          [value]="0"
          (click)="toggleAll()"
          [checked]="allSelected">
          {{ 'SELECTALL' | translate }}
        </mat-option> -->
    
        <!-- Opciones de divisiones -->
        <mat-option *ngFor="let division of divisions" [value]="division.id">
          {{ division.clientdivisionname }}
        </mat-option>
      </mat-select>
    </mat-form-field>       

    <mat-form-field appearance="outline">
      <mat-label>{{ 'STARTDATE' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="fromDate">
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>
  
    <mat-form-field appearance="outline" >
      <mat-label>{{ 'ENDDATE' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerTo" [(ngModel)]="toDate">
      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!fromDate || !toDate">
      Descargar Reporte
    </button>
  </mat-dialog-actions>
  
</div>